import { logger } from '@vista-digital/occ-domain/src'
import { observer } from 'mobx-react'
import type { CSSProperties, FC } from 'react'
import { getSelectedCinemaGroup } from '../cinema-groups/utils/get-selected-cinema-group'
import type { CineColombiaGridRow } from './grid.types'
import { GridElementsComponent } from './GridElementsComponent'
import { TabLayout } from './tabLayout/TabLayout'

export const GridRowComponent: FC<CineColombiaGridRow> = observer(props => {
    const configuredGroups = props.config?.cinemaGroups
    const selectedGroup = getSelectedCinemaGroup()

    if (props.name === 'gridRichText') {
        if (configuredGroups?.length) {
            const match = configuredGroups.some(group => group.nodeId === selectedGroup?.id)

            if (!match) {
                logger.debug('Cinema groups do not match selected cinema group', {
                    configuredGroups,
                    selectedGroup,
                })
                return null
            }
        }
    }

    if (props.name === 'tabLayout') {
        return <TabLayout {...props} />
    }

    if (props.columns && props.columns.length > 0) {
        const rowStyles: CSSProperties = {
            gridTemplateColumns: props.columns
                .map(
                    c =>
                        // Exact percentage values must be used as fr units are not strict enough to prevent overflow
                        `calc(((100% - (${props.columns.length - 1} * var(--grid-column-gap))) / 12) * ${c.size})`
                )
                .join(' '),
        }

        return (
            <div className="grid-row" style={rowStyles}>
                {props.columns.map((column, index) => (
                    <div className="grid-column" key={'grid-column-' + index}>
                        <div className="grid-column__content">
                            <GridElementsComponent {...column} additionalData={props.additionalData} />
                        </div>
                    </div>
                ))}
            </div>
        )
    }
    return null
})
